import { LogoutOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import type React from 'react';
import { signOut } from '@/core/providers/AuthFirebaseProvider';

const LogoutButtonView: React.FC = () => {
  return (
    <Button
      style={{
        order: 1001,
        marginLeft: 16,
      }}
      shape="circle"
      icon={<LogoutOutlined />}
      onClick={async () => await signOut()}
    />
  );
};

export default LogoutButtonView;
